import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "mail-address" }, "メールアドレス", -1)
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "modal-footer" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_base = _resolveComponent("modal-base")!

  return (_openBlock(), _createBlock(_component_modal_base, { onDismiss: _ctx.dismiss }, {
    title: _withCtx(() => [
      _createTextVNode(" メールアドレス追加 ")
    ]),
    "modal-content": _withCtx(() => [
      _createElementVNode("form", {
        onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.mailAddress }]),
              id: "mail-address",
              placeholder: "メールアドレス",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.mailAddress) = $event))
            }, null, 2), [
              [_vModelText, _ctx.values.mailAddress]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.mailAddress)
            }, null, 8, _hoisted_4)
          ])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, "キャンセル"),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
          disabled: !_ctx.meta.valid
        }, "追加", 8, _hoisted_6)
      ])
    ]),
    _: 1
  }, 8, ["onDismiss"]))
}